import _ from 'lodash';
import BaseAccountController from '../../lib/controllers/BaseAccountController';
import queryParameterParser from '../../lib/helpers/queryStringParser';

declare var LtFramework: lt.Static;

export default class ManagePaymentOptionsController extends BaseAccountController {
	public static $inject: string[] = ['$window', '$scope', '$q', 'MembershipResource',
		'CreditCardPurposeResource', 'UserPaymentAccountsResource'];
	public isMember: boolean;

	public cardPurposes: MyAccountApi.ICreditCardPurpose[];
	public clubTabPaymentAccounts: PaymentAccount[];
	public membershipPaymentAccount?: PaymentAccount;
	public recurringServicesAccount?: PaymentAccount;
	public newPaymentAccount: PaymentAccount;
	public additionalPaymentAccounts: PaymentAccount[];
	public generalMessage: string;
	public generalError: string;
	public dualMessage: string;
	public dualError: string;
	public pendingDelete: PaymentAccount;
	public deleteDialogLoading: boolean;
	public deleteConfirmationNeeded: boolean;
	public eftAgreementLoading = false;
	public agreementHtml: string;
	public agreementTitle: string;
	public signatureHtml: string;
	public authenticatedMemberId: number;
	public isEligibleAge = true;
	public paramFlag = false;

	private readonly CreditCardPurposes: MyAccountApi.ICreditCardPurposeResource;
	private readonly UserPaymentAccounts: MyAccountApi.IUserPaymentAccountsResource;
	private readonly Membership: MyAccountApi.IMembershipResource;
	private membership: MyAccountApi.IMembership;
	private loggedInMemberDetails?: MyAccountApi.IMember;
	private readonly $window: ng.IWindowService;
	private readonly $q: ng.IQService;
	private paymentAccounts: MyAccountApi.IUserPaymentAccount[];

	constructor($window: ng.IWindowService, $scope: ng.IScope, $q: ng.IQService,
		Membership: MyAccountApi.IMembershipResource,
		CreditCardPurposes: MyAccountApi.ICreditCardPurposeResource,
		UserPaymentAccounts: MyAccountApi.IUserPaymentAccountsResource) {

		super($scope);
		this.$window = $window;
		this.$q = $q;
		this.Membership = Membership;
		this.CreditCardPurposes = CreditCardPurposes;
		this.UserPaymentAccounts = UserPaymentAccounts;
		this.additionalPaymentAccounts = [];

		const view = queryParameterParser.getParameterByName($window, 'view');
		if (view === 'dues') {
			this.paramFlag = true;
		}
		this.loadInitialData();
	}

	public print(): void {
		this.$window.print();
	}

	/**
	 * Filter function used by the Purposes drop-down.
	 * Warning: this method when called by Angular doesn't have access to 'this', making this method effectively a static method.
	 * From the Angular docs: "The filter function should be a pure function, which means that it should be stateless and idempotent."
	 * We can't mark it as static however since then when transpiled it's not on the prototype, making it not callable by Angular.
	 */
	public shouldShowPaymentPurpose(actual: { description: string, valId: number }, expected: string): boolean {
		// don't show Monthly Dues purposes ever, and don't show Club Tab purposes for non-members
		return actual.description.indexOf('Monthly Dues') === -1
			&& (actual.description.indexOf('Club Tab') < 0 || this.isMember);
	}

	public isLoading(): boolean {
		return !this.membership || !this.membership.$resolved || !this.paymentAccounts || !this.paymentAccounts.$resolved;
	}

	public canDeletePaymentAccount(account: PaymentAccount): boolean {
		return account.canEdit();
	}

	public deletePaymentAccount(account: PaymentAccount, $event: Event): void {
		$event.preventDefault();
		this.generalMessage = '';

		this.pendingDelete = account;
		this.deleteDialogLoading = false;
		this.deleteConfirmationNeeded = true;
		$('#deleteModal').modal();
	}

	public displayClubTabRemovalError($event: Event): void {
		$event.preventDefault();
		this.dualError = 'true';
	}

	public deleteConfirmed(): void {
		this.deleteDialogLoading = true;

		this.pendingDelete.delete(() => {
			const index = this.additionalPaymentAccounts.indexOf(this.pendingDelete);
			this.additionalPaymentAccounts.splice(index, 1);

			this.generalMessage = `You've successfully deleted your '${this.pendingDelete.accountLabel}'.`;
			$('#deleteModal').modal('hide');
			this.deleteConfirmationNeeded = true;
			location.reload();
		}, () => {
			$('#deleteModal').modal('hide');
			this.deleteConfirmationNeeded = true;
			location.reload();
		});
	}

	public updateUrls(): void {
		// determine if the page is being viewed through the mobile app to be used later
		const isMobileAppView = window.location.href.indexOf('.app.html') > -1;
		let href: string;
		let dataPartner: string;
		$('[data-accountid]').each((index, item) => {
			const element = $(item);
			const accountId = element.data('accountid');
			if (accountId) {
				href = element.attr('href');
				href += '&accountId=' + accountId;
				// if the page is in an app view, replace cancelUrl and returnUrl .html values with .app.html
				if (isMobileAppView) {
					// split the href attribute so we can only replace the .html values in the parameters
					const splitHref = href.split('?');
					const hrefParams = splitHref[1].replace(/.html/g, '.app.html');
					href = splitHref[0] + '?' + hrefParams;
				}
				element.attr('href', href);
				dataPartner = element.data('partner');
				dataPartner += '&accountId=' + accountId;
				// if the page is in an app view, replace cancelUrl and returnUrl .html values with .app.html
				if (isMobileAppView) {
					// split the partner attribute/data so we can only replace the .html values in the parameters
					const splitPartner = dataPartner.split('?');
					const partnerParams = splitPartner[1].replace(/.html/g, '.app.html');
					dataPartner = splitPartner[0] + '?' + partnerParams;
				}
				element.data('partner', dataPartner);
				element.attr('data-partner', dataPartner);
			} else {
				// data attribute is present but is set to 0 for EFT accounts, so evaluates as false
				href = element.attr('href');
				href += '&accountId=0';
				if (isMobileAppView) {
					// split the href attribute so we can only replace the .html values in the parameters
					const splitHref = href.split('?');
					const hrefParams = splitHref[1].replace(/.html/g, '.app.html');
					href = splitHref[0] + '?' + hrefParams;
				}
				element.attr('href', href);
				dataPartner = element.data('partner');
				dataPartner += '&accountId=0';
				if (isMobileAppView) {
					// split the partner attribute/data so we can only replace the .html values in the parameters
					const splitPartner = dataPartner.split('?');
					const partnerParams = splitPartner[1].replace(/.html/g, '.app.html');
					dataPartner = splitPartner[0] + '?' + partnerParams;
				}
				element.data('partner', dataPartner);
				element.attr('data-partner', dataPartner);
			}
		});
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		this.membership = this.Membership.get();
		this.paymentAccounts = this.UserPaymentAccounts.query();

		this.$q.all([this.membership.$promise, this.paymentAccounts.$promise]).then(() => {
			// see if the user is authenticated (has an SSO ID)
			const profileStore = LtFramework.getStore('ProfileStore') as lt.IProfileStore;
			this.authenticatedMemberId = profileStore.getInitialData().memberDetails!.memberId;
			if (this.membership.memberDetails && this.membership.memberDetails.length > -1) {
				this.loggedInMemberDetails = _.find(this.membership.memberDetails, (details) => {
					return details.memberId === this.authenticatedMemberId;
				});
				if (this.loggedInMemberDetails != null && this.loggedInMemberDetails.age) {
					// determine if the user is age 18+ and can view payment details/options
					this.isEligibleAge = this.loggedInMemberDetails.age >= 18;
				}
			}

			// if the user has no membership, this.membership's fields will all be empty
			this.isMember = !!this.membership.membershipId;

			const paymentAccounts = this.paymentAccounts.map((account: MyAccountApi.IUserPaymentAccount) => {
				return new PaymentAccount(account, this.membership, {
					purpose: this.cardPurposes
				});
			});

			this.membershipPaymentAccount = _.find(paymentAccounts, (account: PaymentAccount) => {
				return account.purpose.description.indexOf('Monthly Dues') !== -1;
			});

			this.recurringServicesAccount = _.find(paymentAccounts, (account: PaymentAccount) => {
				return account.purpose.description.indexOf('Recurrent') !== -1;
			});

			this.clubTabPaymentAccounts = _.filter(paymentAccounts, (account: PaymentAccount) => {
				return account.purpose.description.indexOf('Club Tab') !== -1;
			});

			if (this.membershipPaymentAccount != null) {
				const primaryIndex = paymentAccounts.indexOf(this.membershipPaymentAccount);
				paymentAccounts.splice(primaryIndex, 1);
			}

			if (this.recurringServicesAccount != null) {
				const primaryIndex = paymentAccounts.indexOf(this.recurringServicesAccount);
				paymentAccounts.splice(primaryIndex, 1);
			}

			this.additionalPaymentAccounts = paymentAccounts;
			const self = this;
			setTimeout(() => {
				self.updateUrls();
				setTimeout(() => {
					LtFramework.actions.bindPartnerUrls();
				}, 500);
			}, 500);
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private loadInitialData(): void {
		this.cardPurposes = this.CreditCardPurposes.query();
	}
}

// tslint:disable-next-line: max-classes-per-file
export class PaymentAccount {
	public id: number;
	public type: string;
	public purpose: MyAccountApi.ICreditCardPurpose;
	public accountLabel: string;
	public accountName: string;
	public accountNumber: string;
	public expMonth: { description: string, valId: string };
	public expYear: string;
	public eligibleCofUsers: MyAccountApi.IMember[];
	public successMessage: string;
	public errorMessage: string;
	public agreement: MyAccountApi.IAgreement;
	public agreementAccepted: boolean;
	public eftAgreement: MyAccountApi.IAgreement;
	public eftAgreementAccepted = false;
	public isBankAccount: boolean;
	public bankName: string;
	public isClubTabPaymentType: boolean;
	public isDualPaymentAccount: boolean;
	public isRecurringPaymentAccount: boolean;

	private readonly paymentAccount: MyAccountApi.IUserPaymentAccount;
	private selectedCofMembers: number[] = [];
	private readonly displaySelectedCofUsers: MyAccountApi.IMember[] = [];
	private readonly purposes: MyAccountApi.ICreditCardPurpose[];

	constructor(paymentAccount: MyAccountApi.IUserPaymentAccount,
		membership: MyAccountApi.IMembership,
		types: {
			purpose: MyAccountApi.ICreditCardPurpose[]
		}) {
		this.purposes = types.purpose;
		this.paymentAccount = paymentAccount;

		this.id = paymentAccount.accountId;
		this.eligibleCofUsers = membership.memberDetails != null ? membership.memberDetails.reduce<MyAccountApi.IMember[]>((members, member) => {
			if (member.cofEligibleFlag) {
				if (paymentAccount.cofMemberIds && paymentAccount.cofMemberIds.indexOf(member.memberId) >= 0) {
					this.selectedCofMembers.push(member.memberId);
					this.displaySelectedCofUsers.push(member);
				}
				members.push(member);
			}

			return members;
		}, []) : [];

		// VISA is the recognized eb services value, but the creditcards lib needs Visa
		this.type = paymentAccount.type === 'VISA' ? 'Visa' : paymentAccount.type;
		this.isBankAccount = this.type === 'Individual Checking' || this.type === 'Commercial Checking EFT' || this.type === 'Savings Account';
		this.bankName = paymentAccount.bankName;

		this.purpose = _.find(types.purpose, (purpose) => {
			return purpose.description === paymentAccount.purpose;
		}) as MyAccountApi.ICreditCardPurpose;

		this.isDualPaymentAccount = this.isDualPaymentType();

		this.isRecurringPaymentAccount = this.isRecurringPaymentType();

		this.isClubTabPaymentType = this.hasClubTabPaymentType();

		this.accountLabel = paymentAccount.accountLabel;
		this.accountName = paymentAccount.accountName;
		this.accountNumber = paymentAccount.accountNumber;

		this.accountLabel = this.paymentAccount.accountLabel;
	}

	public memberCofSelected(memberId: number): boolean {
		return this.selectedCofMembers.indexOf(memberId) >= 0;
	}

	public toggleUseForClubTab(model: ng.INgModelController): void {
		const match = model.$modelValue ? ['Club Tab', 'Monthly Dues'] : ['Monthly Dues'];

		this.purpose = _.find(this.purposes, (purpose) => {
			return _.reduce<string, boolean>(match, (contains, matcher) => {
				return contains && (purpose.description.indexOf(matcher) > -1);
			}, true);
		}) as MyAccountApi.ICreditCardPurpose;

		this.isClubTabPaymentType = model.$modelValue;

		if (!this.isClubTabPaymentType) {
			this.selectedCofMembers = [];
			this.agreementAccepted = false;
		}
	}

	public getTitle(): string {
		if (this.isMembershipDuesPaymentType()) {
			if (this.purpose!.description.indexOf('Recurrent') >= 0) {
				return 'Dues';
			} else {
				return 'Dues and Recurring Services';
			}
		} else if (!this.purpose || this.purpose.description.indexOf('Recurrent') >= 0) {
			return 'Recurring Services';
		} else if (!this.purpose || this.purpose.description.indexOf('Other') >= 0) {
			return 'Additional Payment';
		} else {
			return 'Club Tab';
		}
	}

	public canEdit(): boolean {
		return this.type !== 'Individual Checking' && !this.paymentAccount.viewOnly;
	}

	public canEditLabel(): boolean {
		// Labels on Dues and Recurring Services accounts shouldn't be editable, per MYACCT-410
		return this.canEdit() && !this.isMembershipDuesPaymentType();
	}

	public toggleCofAuthorization(member: MyAccountApi.IMember): void {
		const index = this.selectedCofMembers.indexOf(member.memberId);

		if (index >= 0) {
			this.selectedCofMembers.splice(index, 1);
		} else {
			this.selectedCofMembers.push(member.memberId);
		}
	}

	public convertToCC(evt: Event): void {
		if (evt && evt.preventDefault) {
			evt.preventDefault();
		}

		if (!this.paymentAccount.viewOnly) {
			this.type = 'CreditOrDebit';
			this.isBankAccount = false;
			this.accountNumber = '';
			this.bankName = '';
		}
	}

	// tslint:disable-next-line: ban-types
	public delete(success?: Function, error?: Function): void {
		this.successMessage = '';
		this.errorMessage = '';

		this.paymentAccount.$delete(success, (err: MyAccountApi.IServiceFailureResponse) => {
			this.errorMessage = '';

			if (err.data && err.data.validationErrors) {
				if (err.data.validationErrors[0].message.indexOf('Autoship') >= 0) {
					this.errorMessage = 'A valid payment method is required with your Autoship account.'
						+ ' You can delete after updating your account information <a href="https://shop.lifetime.life">here</a>.';
				} else {
					err.data.validationErrors.forEach((err2) => {
						this.errorMessage += `${err2.key}: ${err2.message}\n`;
					});
				}
			} else {
				this.errorMessage = 'There was an error on the server and we were unable to delete this' +
					' payment option at this time.';
			}

			if (error) {
				error(err);
			}
		});
	}

	public isMembershipDuesPaymentType(): boolean {
		return this.purpose && this.purpose.description.indexOf('Monthly Dues') >= 0;
	}

	private hasClubTabPaymentType(): boolean {
		return this.purpose && this.purpose.description.indexOf('Club Tab') >= 0;
	}

	private isDualPaymentType(): boolean {
		return (this.purpose.description.indexOf('Club Tab') !== -1 &&
			this.purpose.description.indexOf('Monthly Dues') !== -1) ||
			(this.purpose.description.indexOf('Club Tab') !== -1 &&
				this.purpose.description.indexOf('Recurrent') !== -1);
	}

	private isRecurringPaymentType(): boolean {
		return this.purpose.description.indexOf('Recurrent') !== -1;
	}
}
